import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import FlexEUploadCard from '@/components/flexe/FlexEUploadCard';
import FlexESimulationForm from '@/components/flexe/FlexESimulationForm';
import { NetworkStatusIndicator } from '@/components/flexe/NetworkStatusIndicator';
import FlexEGuideModal from '@/components/flexe/FlexEGuideModal';

export default function CRMFlexENew() {
  const navigate = useNavigate();
  const [uploadId, setUploadId] = useState<string | null>(null);

  const handleSimulationComplete = (simId: string) => {
    // Navigate to detail page after successful simulation
    navigate(`/crm/flexe/${simId}`);
  };

  return (
    <div className="container mx-auto p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate('/crm/flexe')}
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div>
            <h1 className="text-3xl font-bold">Nieuwe Flex-E Simulatie</h1>
            <p className="text-muted-foreground mt-2">
              Upload kwartierwaarden en configureer de batterij simulatie
            </p>
          </div>
        </div>
        <FlexEGuideModal />
      </div>

      <NetworkStatusIndicator />

      <div className="space-y-6">
        {/* Step 1: Upload */}
        <FlexEUploadCard onUploadSuccess={setUploadId} />

        {/* Step 2: Simulation Configuration */}
        {uploadId && (
          <FlexESimulationForm 
            uploadId={uploadId} 
            onSimulationComplete={handleSimulationComplete}
          />
        )}
      </div>
    </div>
  );
}
